import {mapState, mapGetters, mapMutations} from 'vuex';

import gsap from "gsap";
import promokit from '@/utils/promokit';

export default {
  data() {
    return {
      name: this.$options.name,
      enterMotion: null,
      hideMotion: null,
      moveEle:null,
      canDrag:true,
      autoPlay:true,
      isMobile:promokit.util.isMobile(),
    };
  },

  comments:[
  ],
  computed: {
    ...mapState([
      'staticPath',
      'isLayer',
      'breakPoint',
      'isMovePage',
      'currentPage',
      'enterPage',
      'documentSize',
      'clipQuery',
      'selectClip'
    ]),
    ...mapGetters([
      'getDragPos'
    ])
  },
  methods: {
    ...mapMutations([
      'setCurrentPage',
      'setIsIntro',
      'setIsMovePage',
      'setEnterPage',
      'setSelectClip',
      'setIsLayer'
    ]),
    moveEles(pos){
      if(this.getIsMovePage || this.getIsLayer)return;
      this.moveEle.forEach(ele =>{
        let speed = ele.dataset.speed;
        let easeTime = 0.1;
        let x, y;
        if(this.isMobile){
          const matrix = new DOMMatrixReadOnly(getComputedStyle(ele).transform);
          if(ele.dataset.moveStandard != undefined){
            speed = speed/10
          }
          if(pos.c){
            ele.dataset.sposx =matrix.m41;
          }
          x = Number(ele.dataset.sposx) - (pos.s.x - pos.d.x)/speed;
          if(ele.dataset.moveStandard != undefined){
            if((ele.offsetWidth- window.innerWidth)/2 < Math.abs(x)){
              this.canDrag = false;
              return;
            }else{
              this.canDrag = true;
            };
          }
          if(!this.canDrag)return;

          gsap.to(ele, easeTime, {x:x});
        }else{
          const cX = (pos.d.x - window.innerWidth/2)/ (window.innerWidth/2) *-1;
          const cY = (pos.d.y - window.innerHeight/2)/ (window.innerHeight/2) *-1;
          if(ele.dataset.moveStandard != undefined){
            x =(ele.offsetWidth- window.innerWidth) /2 * cX;// (ele.offsetWidth- window.innerWidth) /2 / (pos.d.x - window.innerWidth/2) //((ele.offsetWidth- window.innerWidth)) / // (ele.offsetWidth- window.innerWidth)/pos.d.x/2
            y =(ele.innerHeight- window.innerHeight) /2 * cY;// (ele.offsetWidth- window.innerWidth) /2 / (pos.d.x - window.innerWidth/2) //((ele.offsetWidth- window.innerWidth)) / // (ele.offsetWidth- window.innerWidth)/pos.d.x/2
          }else{
            x= cX * speed;
            y= cY * speed / 7 *-1;
          }
          if(ele.dataset.moveStandardx != undefined)y = 0;
          easeTime = 0.3;


          if(pos.isWheel){
            return;
          }
          gsap.to(ele, easeTime, {x:x, y:y});
        }
        //ele.style.transform = `translateX(${x}px)`
      })
    },
    enter(el, done){
      this.setMotion();
      this.enterMotion.eventCallback("onComplete", ()=>{
        done();
      })
      this.enterMotion.timeScale(1);
      this.enterMotion.play();

      this.setCurrentPage(this.name);
      this.setEnterPage(this)
    },
    leave(el, done){
      // this.leaveStart();
      // this.enterMotion.eventCallback("onReverseComplete", ()=>{
      //   done();
      // })
      // this.setIsMovePage(true)
      // this.enterMotion.timeScale(2);
      // this.enterMotion.reverse();
    },
    leaveStart(){

    }

  },
  created(){

  },
  mounted(){
    this.moveEle = this.$el.querySelectorAll('[data-move]')
  },

  watch:{
    getDragPos(val){

      this.moveEles(val)
    }
  }


}
